
import Vue from 'vue';
import {BoPanel, IOnOffHandlers} from 'bonomo';
import Component from 'vue-class-component';

import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IShortLocker } from '@/model/shortInterfaces';
import { IErrors } from '@/model/IErrors';
import { IUser } from '@/model/User/UserInterface';
import UserChip from '@/components/shared/chips/UserChip.vue';
import LockerChip from '@/components/shared/chips/LockerChip.vue';
import Datim from "@/components/shared/Datim.vue";
import UserLogs from "@/components/user/logs/UserLogs.vue"
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";
import {IAuthUserData} from "@/store/modules/authModule";
import UserStatus from "@/views/user/UserStatus.vue";
import UserMigration from "@/components/user/widget/UserLockerMigration.vue";
import UserLockerCompany from "@/components/user/widget/UserLockerCompany.vue";
import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
import UserNav from "@/components/user/widget/UserNav.vue";
import { LockerIntegration } from "@/constants/locker";

const userModule = namespace('userModule');
const lockerModule = namespace('lockerModule');
const userPermissionModule = namespace("userPermissionModule");
const authModule = namespace("authModule");

@Component({
	name: 'User',
	components: {
    LockerSearch,
    UserLockerCompany,
    UserMigration,
    UserStatus,
		BoPanel,
    Datim,
		UserChip,
    LockerChip,
    UserLogs,
    SimpleConfirmationDialog,
    UserNav,
	},
})
export default class User extends Vue {
	@Prop()
	protected userId!: number;

	@userModule.Getter('user')
	protected user!: IUser;

	@userModule.Getter('errors')
	protected errors!: IErrors;

  @userModule.Getter('dashboard')
  protected dashboard!: any;

  @userModule.Action('fetchDashboard')
  private fetchDashboard!: (userId: number) => Promise<any>;

  @userModule.Action('resendPasswordChangeEmail')
	private resendPasswordChangeEmail!: (userId: number) => void;

  @userModule.Action('regenerateDeliveryToken')
  private regenerateDeliveryToken!: (payload: { userId: number }) => void;

  @userModule.Action('resetUser')
	private resetUser!: () => void;

	@userModule.Action('fetchUser')
	private fetchUser!: (userId: number) => IUser;

  @userModule.Action('clearOrders')
  private clearOrders!: () => void;

  @lockerModule.Getter('lockers')
	private lockers!: IShortLocker[];

	@lockerModule.Action('fetchLockers')
	private fetchLockers!: () => void;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  @userPermissionModule.Action('fetchPermissions')
  protected fetchPermissions!: (userId: number) => Promise<any>;

  @userPermissionModule.Action('fetchPermissionsUser')
  protected fetchPermissionsUser!: (userId: number) => Promise<any>;

  get isSelf() {
    return '' + this.$route.params.userId === '' + this.authUser.id;
  }

  get isSpikeV2() {
    const locker = this.findLocker(this.user.locker_id);

    if (!locker)
    {
      return false;
    }

    return locker.integration === LockerIntegration.spike_v2;
  }

  get canChangeDeliveryCode(): boolean {
    return this.$canAction('users/allowCreatingNewDeliveryCodes') && !!this.user.locker_id;
  }

  private showSendPswEmailDialog = false;
  private disableSendPswEmail = false;
  private showDeliveryTokenDialog = false;
  private submittingDeliveryToken = false;
  protected loading: boolean = true;
	protected submitting: boolean = false;
  private subscribes: IOnOffHandlers = {};
  private stopSubmitting() {
    this.submitting = false;
  }

  created() {
    this.subscribes = this.$ons({
      'login.OK': this.loadData,
      'backend.call.OK.emailSent': this.stopSubmitting,
      'backend.call.KO': this.stopSubmitting,
      'backend.call.OK.deliveryTokenRegenerated': this.stopSubmittingDeliveryToken,
      'backend.call.KO.deliveryTokenRegenerated': this.stopSubmittingDeliveryToken,
    });
  }
  private stopSubmittingDeliveryToken() {
    this.submittingDeliveryToken = false;
  }
	loadData() {
		this.fetchUser(this.userId);
    this.fetchDashboard(this.userId);
    this.fetchLockers();
    this.clearOrders();
	}

  findLocker(id: number): IShortLocker {
		return this.lockers.find((locker: IShortLocker) => locker.id == id) || {} as IShortLocker;
	}

  onAcceptSendPswEmailBtn() {
    this.submitting = true;
    this.resendPasswordChangeEmail(this.userId);
    this.showSendPswEmailDialog = false;
  }

  onOpenSendPswEmailDialog() {
    this.showSendPswEmailDialog = true;
  }

  onAcceptDeliveryTokenBtn() {
    this.submittingDeliveryToken = true;
    this.regenerateDeliveryToken({ userId: this.userId });
    this.showDeliveryTokenDialog = false;
  }

  onOpenDeliveryTokenDialog() {
    this.showDeliveryTokenDialog = true;
  }

}
